import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

class CustomVariantPrice extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');

    if (!closestSection) return;

    closestSection.addEventListener(
      ThemeEvents.variantUpdate,
      this.updatePrice
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');

    if (!closestSection) return;

    closestSection.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updatePrice
    );
  }

  updatePrice = (event) => {
    // Make sure this update belongs to this product
    if (
      event.detail.data.newProduct
    ) {
      this.dataset.productId =
        event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // Find our custom price in the newly rendered HTML
    const newPrice = event.detail.data.html.querySelector(
      '[data-custom-variant-price]'
    );

    if (!newPrice) return;

    // Replace the old custom price with the newly rendered one
    this.replaceWith(newPrice);
  };
}

if (!customElements.get('custom-variant-price')) {
  customElements.define(
    'custom-variant-price',
    CustomVariantPrice
  );
}